// Seed fixtures for the Settings mock — host-owned (ADR-0014).
//
// Ported verbatim from the pbdesign wireframe `data/settings.ts` SEED_SETTINGS.
// Split into the user-scoped (personal) and tenant-scoped (workspace) halves so
// the mock client can partition them the way the live `/v1/settings/*` endpoints
// will: personal prefs by userId, workspace config by tenantId.

import { allModulesEnabled } from "./roster.js";
import type { PersonalSettings, WorkspacePrefs } from "./types.js";

/** User-scoped seed (PlayerAI + Notifications). The launcher preference is
   live on Playbook BE (PB-5134) and has no seed. */
export const SEED_PERSONAL: PersonalSettings = {
  playerai: {
    defaultMode: "ask-first",
    tone: "Professional",
    verbosity: "Balanced",
    enabledByModule: {
      ...allModulesEnabled(),
      "transformation-map": false,
    },
  },
  notifications: {
    channels: { email: true, inApp: true },
    alertsById: {
      "dpm-thresholds": true,
      "hoshin-reviews": true,
      "solve-updates": true,
      "lama-campaigns": false,
      "kpi-anomalies": true,
    },
    digest: "weekly",
  },
};

/** Tenant-scoped seed (members + org-wide module enablement). Org branding
   moved to the real tenant-configuration API (PB-45/PB-552). */
export const SEED_WORKSPACE: WorkspacePrefs = {
  members: [
    {
      id: "m-1",
      name: "Ada Okonkwo",
      email: "ada@northwind.io",
      role: "Owner",
    },
    { id: "m-2", name: "Liam Chen", email: "liam@northwind.io", role: "Admin" },
    {
      id: "m-3",
      name: "Priya Nair",
      email: "priya@northwind.io",
      role: "Member",
    },
    {
      id: "m-4",
      name: "Marcus Webb",
      email: "marcus@northwind.io",
      role: "Member",
    },
    {
      id: "m-5",
      name: "Sofia Reyes",
      email: "sofia.reyes@contractor.io",
      role: "Viewer",
      pending: true,
    },
  ],
  moduleEnabled: {
    ...allModulesEnabled(),
    brainstorm: false,
  },
};
